import ExistingRedemptionCard from "./ExistingRedemptionCard.jsx";

function AdminChoiceStep({
  driverProfile,
  existingOrder,
  onContinueRedemption,
  onOpenImport,
  onBack,
}) {
  const nextStepLabel =
    driverProfile?.rewardGroup === "manual" ? "Continue to Manual Review" : "Continue to Rewards";

  return (
    <div className="landstar-step-content">
      <div className="landstar-entry-card landstar-access-card">
        <p className="landstar-kicker">Admin Tools</p>
        <h3>Choose what you want to do next</h3>
        <p className="landstar-intro-copy">
          This email is allowlisted for the Landstar admin import flow. You can either continue as a
          normal redemption user for testing, or open the spreadsheet importer.
        </p>

        <ExistingRedemptionCard orderStatus={existingOrder} adminContext />

        <div className="landstar-admin-choice-grid">
          <div className="landstar-status-card landstar-admin-choice-card">
            <p className="landstar-kicker">Test Redemption</p>
            <h4>{nextStepLabel}</h4>
            <p className="landstar-helper-text">
              Keep using this validated driver profile and continue through the standard reward flow.
            </p>
            <button
              type="button"
              className="landstar-primary-button"
              onClick={onContinueRedemption}
              disabled={Boolean(existingOrder)}
            >
              {existingOrder ? "Redemption Already Submitted" : nextStepLabel}
            </button>
          </div>

          <div className="landstar-status-card landstar-admin-choice-card">
            <p className="landstar-kicker">Eligibility Code</p>
            <h4>Open Spreadsheet Upload</h4>
            <p className="landstar-helper-text">
              Upload a new Landstar eligibility spreadsheet and update the current table from the admin
              importer.
            </p>
            <button
              type="button"
              className="landstar-secondary-button"
              onClick={onOpenImport}
            >
              Open Import Page
            </button>
          </div>
        </div>

        <hr className="landstar-section-divider" />

        <div className="landstar-inline-actions landstar-inline-actions-start">
          <button type="button" className="landstar-secondary-button" onClick={onBack}>
            Back
          </button>
        </div>
      </div>
    </div>
  );
}

export default AdminChoiceStep;
